import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { EditService } from './edit.service';
import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';
import { IAutoMatchSettings } from '../interfaces/auto-job-matching/auto-match-settings';
import { ICustomer } from '../interfaces/customer';
import { AutoMatchJobInfo } from '../interfaces/auto-job-matching/auto-match-job-info';

@Injectable({ providedIn: 'root' })
export class AutoJobMatchService extends EditService<any, null> {
  url = '/api/capacityMatching';
  autoMatchSettingsUrl = this.url + '/autoMatchSettings';
  entityTitle = '';

  constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
    super(http, handlersFactory);
  }

  addCustomerExclude(settingsId: number, customerId: number) {
    var newUrl = this.url + '/addExcludedCustomer';

    return this.http
      .post<any>(newUrl, { autoMatchSettingId: settingsId, customerId: customerId })
      .toPromise();
  }

  removeCustomerExclude(settingsId: number, customerId: number) {
    var newUrl = this.url + '/removeExcludedCustomer/' + settingsId + '/' + customerId;

    return this.http.delete<any>(newUrl).toPromise();
  }

  getExcludedCustomers(autoMatchSettingId: number): Promise<ICustomer[]> {
    return this.http.get<any>(this.url + '/excludedCustomers/' + autoMatchSettingId).toPromise();
  }

  getAutoMatchSettingsList(): Promise<IAutoMatchSettings[]> {
    return this.http.get<any>(this.url + '/autoMatchSettingsList').toPromise();
  }

  getAutoMatchSettings(settingsId): Promise<IAutoMatchSettings> {
    return this.http.get<any>(this.autoMatchSettingsUrl + '/' + settingsId).toPromise();
  }

  deleteSetting(settingsId: number) {
    console.log('DELETING SETTINGS ID ' + settingsId);

    return this.http.delete<any>(this.autoMatchSettingsUrl + '/' + settingsId).toPromise();
  }

  createSetting(autoMatchSettings) {
    return this.handleRequest<any>(
      this.http.post<IAutoMatchSettings>(this.autoMatchSettingsUrl, autoMatchSettings),
      this.handlersFactory.getForUpdate(this.entityTitle),
    );
  }

  saveSetting({ autoMatchSettings }) {
    var suffix = '/autoMatchSettings';

    if (autoMatchSettings.id == 0 || autoMatchSettings.id == null) {
      return this.handleRequest<any>(
        this.http.post<IAutoMatchSettings>(this.url + suffix, autoMatchSettings),
        this.handlersFactory.getForUpdate(this.entityTitle),
      );
    } else {
      var newUrl = this.url + suffix + '/' + autoMatchSettings.id;

      return this.handleRequest<any>(
        this.http.put<IAutoMatchSettings>(newUrl, autoMatchSettings),
        this.handlersFactory.getForUpdate(this.entityTitle),
      );
    }
  }

  getAutoMatchedJobsByProfile(settingsId: number): Promise<AutoMatchJobInfo[]> {
    return this.http
      .get<AutoMatchJobInfo[]>(`${this.url}/getAutoMatchedJobsByProfile/${settingsId}`)
      .toPromise();
  }
}
